module.exports = __webpack_public_path__ + "static/assets/a23892b230c6d987e43994efa487da0a.png";